export interface DeepseekResponse {
  text?: string;
  error?: string;
  detail?: string;
}

/**
 * 调用部署在 Netlify 上的服务端函数（netlify/functions/deepseek.ts），
 * 由该函数持服务端 DEEPSEEK_API_KEY 转发给 DeepSeek，Key 不暴露给前端。
 */
export async function callDeepseek(prompt: string): Promise<DeepseekResponse> {
  try {
    const res = await fetch('/.netlify/functions/deepseek', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ prompt }),
    });
    if (!res.ok) {
      return { error: `请求失败（HTTP ${res.status}）` };
    }
    const data = (await res.json()) as DeepseekResponse;
    return data;
  } catch (e) {
    const msg = e instanceof Error ? e.message : '网络请求失败';
    return { error: msg };
  }
}
